// extracted by mini-css-extract-plugin
export var AddressSec = "CustomMessage-module--AddressSec--138f5";
export var BtnSec = "CustomMessage-module--BtnSec--31ccd";
export var ButtonContainer = "CustomMessage-module--ButtonContainer--b56ea";
export var ContentContainer = "CustomMessage-module--ContentContainer--2dcd7";
export var FailureModal = "CustomMessage-module--FailureModal--138e8";
export var HeaderSec = "CustomMessage-module--HeaderSec--cd525";
export var ImagecropSec = "CustomMessage-module--ImagecropSec--6e655";
export var MessageContainer = "CustomMessage-module--MessageContainer--4a1cc";
export var NewDropDown = "CustomMessage-module--NewDropDown--0a24f";
export var NewDropDownIcon = "CustomMessage-module--NewDropDownIcon--49fde";
export var ShareBtnSec = "CustomMessage-module--ShareBtnSec--193de";
export var ShareSec = "CustomMessage-module--ShareSec--db198";
export var SubmitBtn = "CustomMessage-module--SubmitBtn--7d33a";
export var SuccessModal = "CustomMessage-module--SuccessModal--72fa0";
export var TermsContainer = "CustomMessage-module--TermsContainer--13358";
export var addeventatc = "CustomMessage-module--addeventatc--c9a38";
export var addeventatc_icon = "CustomMessage-module--addeventatc_icon--d2042";
export var addressBtnContainer = "CustomMessage-module--addressBtnContainer--bb412";
export var btn = "CustomMessage-module--btn--8b9a7";
export var btnContainer = "CustomMessage-module--btnContainer--49c19";
export var btnoutline = "CustomMessage-module--btnoutline--752b9";
export var centerbtnoutline = "CustomMessage-module--centerbtnoutline--832aa";
export var cityInput = "CustomMessage-module--cityInput--5ad0d";
export var citySec = "CustomMessage-module--citySec--23535";
export var clsBtn = "CustomMessage-module--clsBtn--9e759";
export var countrySec = "CustomMessage-module--countrySec--ecce5";
export var custom_sec = "CustomMessage-module--custom_sec--3ec92";
export var dialogClass = "CustomMessage-module--dialogClass--fed08";
export var dropdownItem = "CustomMessage-module--dropdownItem--71005";
export var dropitemValue = "CustomMessage-module--dropitemValue--f9755";
export var email_security_icon = "CustomMessage-module--email_security_icon--a978c";
export var error = "CustomMessage-module--error--52472";
export var errorMsg = "CustomMessage-module--errorMsg--90c94";
export var fileType = "CustomMessage-module--fileType--1fab9";
export var imgoutline = "CustomMessage-module--imgoutline--525a8";
export var inputBox = "CustomMessage-module--inputBox--a71d5";
export var inputContainer = "CustomMessage-module--inputContainer--87b6e";
export var launchApp = "CustomMessage-module--launchApp--15dfc";
export var location_icon = "CustomMessage-module--location_icon--eeb2b";
export var mob_icon = "CustomMessage-module--mob_icon--78da4";
export var modalFooter = "CustomMessage-module--modal-footer--6571c";
export var modalSec = "CustomMessage-module--modalSec--42a59";
export var navigateSec = "CustomMessage-module--navigateSec--5117b";
export var sendAndcloseButton = "CustomMessage-module--sendAndcloseButton--ce0e7";
export var specialinstructionSec = "CustomMessage-module--specialinstructionSec--2be7a";
export var submitBtn = "CustomMessage-module--submitBtn--afad3";
export var succesContainer = "CustomMessage-module--succesContainer--0e424";
export var successtxt = "CustomMessage-module--successtxt--23671";
export var termsContainer = "CustomMessage-module--termsContainer--c8750";
export var termsContentSec = "CustomMessage-module--termsContentSec--29b0c";
export var titletxt = "CustomMessage-module--titletxt--4b2ed";
export var user_icon = "CustomMessage-module--user_icon--f9655";